import { get } from 'lodash-es';
import type { Answers } from '../../graphql/queries';
import type { FIELD_IDS } from '../../constants/wizard';

export function getAnswersForFields({ fieldIds, answers }: { fieldIds: Array<FIELD_IDS>; answers: Answers }) {
  return Object.fromEntries(
    fieldIds.map((fieldId) => {
      if (fieldId.includes('[]')) {
        // currentIncomes[] - translates to doing a forEach on answers.currentIncomes
        const baseFieldId = fieldId.split('[')[0];
        const answerArray: Array<Answers> = get(answers, baseFieldId);
        if (answerArray && answerArray.length > 0) {
          return [fieldId, answerArray.map((_, index) => get(answers, fieldId.replace('[]', `[${index}]`)))];
        } else {
          return [fieldId, null];
        }
      } else {
        return [fieldId, getAnswerForField({ fieldId, answers })];
      }
    }),
  );
}

export function getAnswerForField({ fieldId, answers }: { fieldId: FIELD_IDS; answers: Answers }) {
  const value = get(answers, fieldId);
  return getAnswerDisplayValue(value);
}

export function getAnswerDisplayValue(value: unknown) {
  return typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value;
}
